import { Scales } from "by/gamefactory/canvas/CanvasScaler";
import { ICanvasScaler } from "by/gamefactory/canvas/ICanvasScaler";
import { BaseView } from "by/gamefactory/scene/viewable/BaseView";
import { PromiseCompletionSource } from "by/gamefactory/shared/async/PromiseCompletionSource";
import { Graphics, IDestroyOptions } from "pixi.js";

export class BaseScalableView<T> extends BaseView<T> {
    protected readonly canvasScaler: ICanvasScaler;
    private readonly fixedWidth: number;
    private readonly fixedHeight: number;

    public constructor(operationControls: PromiseCompletionSource<T>, canvasScaler: ICanvasScaler) {
        super(operationControls);
        this.canvasScaler = canvasScaler;
        this.fixedWidth = this.canvasScaler.referenceWidth;
        this.fixedHeight = this.canvasScaler.referenceHeight;
    }

    public start(): void { }
}